import styled from 'styled-components';

export const MerchantSalesReportWrapper = styled.div``;
